<template>
  <div>
    <form
      ref="form"
      id="form_id"
      class="row g-3 needs-validation"
      novalidate
      @submit.prevent="addRuleset"
    >
      <div
        class="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <div class="row">
          <div class="col-10">
            <h1 class="h2 text-muted">MAPPING ENGINE / ADD RULESET</h1>
          </div>

          <div class="col-1">
            <button
              type="button"
              class="btn btn-danger"
              id="disbut"
              @click="$router.push('/rulesets')"
            >
              Discard
            </button>
          </div>
          <div class="col-1">
            <button class="btn btn-primary" type="submit" id="savebut">
              Save
            </button>
          </div>
        </div>
      </div>
      <div v-if="error" class="alert alert-danger" role="alert">
        Error: {{ reason }}
      </div>
      <div class="col-md-7">
        <label for="fullname" class="form-label">Ruleset Name</label>
        <input
          class="form-control"
          id="fullname"
          v-model="ruleset_name"
          required
        />
        <div class="invalid-feedback">
          Ruleset Name is required!
        </div>
      </div>
      <div class="col-md-7">
        <label class="form-label">Insurer</label>
        <select
          class="form-select"
          v-model="insurer_id"
          required
          @change="getCalculators"
        >
          <option
            v-for="insurer in insurers"
            v-bind:value="insurer.insurer_id"
            :key="insurer.insurer_id"
          >
            {{ insurer.insurer_name }}
          </option>
        </select>
        <div class="invalid-feedback">
          Insurer is required!
        </div>
      </div>
      <div class="col-md-7">
        <label for="loginname" class="form-label">Calculator</label>
        <select
          class="form-select"
          v-model="calculator_id"
          required
          @change="getInsurer"
        >
          <option
            v-for="calculator in calculators"
            v-bind:value="calculator.calculator_id"
            :key="calculator.calculator_id"
          >
            {{ calculator.calculator_name }}
          </option>
        </select>
        <div class="invalid-feedback">
          Calculator is required!
        </div>
      </div>
      <div class="col-md-7">
        <label for="fullname" class="form-label">Internal Note</label>
        <input class="form-control" id="fullname" v-model="internal_note" />
        <div class="invalid-feedback">
          Ruleset Name is required!
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import config from "../../config";
export default {
  data() {
    return {
      ruleset_name: "",
      calculators: [],
      calculator_id: "",
      insurers: [],
      insurer_id: "",
      internal_note: "",
      error: false,
      reason: "",
    };
  },
  methods: {
    async getInsurer() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            calculator_id: this.calculator_id,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/get_single_calculator",
        requestOptions
      );
      const data = await response.json();
      this.insurer_id = data["calculator_details"]["insurer_id"];
    },
    async getCalculators() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            insurer_id: this.insurer_id,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/get_calculator_using_insurer",
        requestOptions
      );
      const data = await response.json();
      this.calculators = data;
    },
    async addRuleset() {
      const form = document.getElementById("form_id");
      if (form.checkValidity()) {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              ruleset_name: this.ruleset_name,
              calculator_id: this.calculator_id,
              insurer_id: this.insurer_id,
              internal_note: this.internal_note,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/add_ruleset",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Added"]) this.$router.push("/rulesets");
        else {
          this.error = true;
          this.reason = data["reason"];
        }
      }
    },
  },
  async mounted() {
    const cres = await fetch(config.baseURL + "/get_calculators", {
      credentials: "include",
    });
    const cdata = await cres.json();
    this.calculators = cdata;
    const ires = await fetch(config.baseURL + "/get_insurers", {
      credentials: "include",
    });
    const idata = await ires.json();
    this.insurers = idata;
    const form = document.getElementById("form_id");
    form.addEventListener(
      "submit",
      function(event) {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add("was-validated");
      },
      false
    );
  },
};
</script>

<style scoped></style>
